import { postData } from './postData';
import { cleanupOutcomeEndpoint } from '../constants';

// Report a Delete attempt outcome to UCMS. A SUCCEEDED Delete ends the VSC's association
// (marked erased); every attempt appends a VscCleanupAudit event. Contract-first: the
// endpoint is added in the UCMS plan.
export async function reportCleanupOutcome({ ctx, attemptStatus, partialDetail, results, appDispatch }) {
    const { action, initiatorType, correlationId, device } = ctx || {};
    const body = {
        // `user` is the device owner; the Portal privilege interceptor
        // (AllowedPrivilegeValidator) resolves the SELF/OTHER scope from this key,
        // matching the convention used by every other device action endpoint. The
        // UCMS request model ignores it (targetUser is the canonical field).
        user: device && device.user,
        action,
        initiatorType,
        correlationId: correlationId || null,
        targetUser: device && device.user,
        targetDeviceCuid: device && device.serial,
        targetVsc: device && device.serial,
        attemptStatus,
        partialDetail: partialDetail || null,
        results,
    };
    return postData({
        endpoint: `${cleanupOutcomeEndpoint}/${device && device.type}/${device && device.serial}`,
        body,
        appDispatch,
    });
}
